
define('ldsh!modules/editor/templates/correodirect_option_view', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<!-- div class="ed-form-group ed-form-group-inline js-fieldmapping ed-user-item" data-field="' +
((__t = ( text )) == null ? '' : __t) +
'" -->\n  <label class="col-md-3 control-label" data-i18n="' +
((__t = ( text ? "" : localizedTranslationKey )) == null ? '' : __t) +
'">' +
((__t = ( text )) == null ? '' : __t) +
'</label>\n  <div class="col-md-9">\n    <select class="ed-form-control ed-form-item-full" data-field="' +
((__t = ( text )) == null ? '' : __t) +
'"></select>\n  </div>\n<!-- /div -->\n';

}
return __p
};});

